import React, { createRef } from "react";
import { NSBox, NSBoxBoolean, NSBoxEnum, NSBoxInteger, NSBoxString, NSColumn, NSRow } from "namirasoft-site-react";
import { NSARouterMakerProps, NSBoxSecret } from "namirasoft-account-react";
import { ProviderLimitPerUnit, ProviderRow, ProviderType } from "namirasoft-email-sender";
import { EmailSenderEntities } from "../EmailSenderEntities";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";
import EmailSenderLayout from "../EmailSenderLayout";

export interface ProviderEditPageProps extends NSARouterMakerProps, EmailSenderRouterProps
{
	isEdit: boolean;
}

interface ProviderEditPageState
{
	type: ProviderType
}

export default class ProviderEditPage extends React.Component<ProviderEditPageProps, ProviderEditPageState> 
{
	private NSBoxString_Name = createRef<NSBoxString>();
	private NSBoxString_Region = createRef<NSBoxString>();
	private NSBoxSecret_AccessKey = createRef<NSBoxSecret>();
	private NSBoxSecret_SecretKey = createRef<NSBoxSecret>();
	private NSBoxString_From = createRef<NSBoxString>();
	private NSBoxEnum_Type = createRef<NSBoxEnum<ProviderType>>();
	private NSBoxString_Host = createRef<NSBoxString>();
	private NSBoxInteger_Port = createRef<NSBoxInteger>();
	private NSBoxSecret_Username = createRef<NSBoxSecret>();
	private NSBoxSecret_Password = createRef<NSBoxSecret>();
	private NSBoxBoolean_Limit = createRef<NSBoxBoolean>();
	private NSBoxInteger_Limit_Count = createRef<NSBoxInteger>();
	private NSBoxInteger_Limit_Per_Value = createRef<NSBoxInteger>();
	private NSBoxEnum_Limit_Per_Unit = createRef<NSBoxEnum<ProviderLimitPerUnit>>();

	constructor(props: ProviderEditPageProps)
	{
		super(props);
		this.state = {
			type: ProviderType.Gmail
		};
	}
	override render()
	{
		let extraTabs = [];
		extraTabs.push(
			{
				title: "Limit",
				clicked: true,
				getContent: () =>
				{
					return (
						<NSColumn style={{ width: NSBox.width.double }}>
							<NSRow>
								<NSBoxBoolean
									ref={this.NSBoxBoolean_Limit}
									title="Limit"
									required
									style={{ width: "100%" }}
									defaultValue={false}
									onChanged={() => this.setState({})}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Limit.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Limit_Count}
									title="Limit Count"
									required
									min={0}
									style={{ width: "100%" }}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Limit.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Limit_Per_Value}
									title="Limit Per Value"
									required
									min={1}
								/>
								<NSBoxEnum<ProviderLimitPerUnit>
									ref={this.NSBoxEnum_Limit_Per_Unit}
									title="Limit Per Unit"
									required
									multiple={false}
									getEnumObject={() => ProviderLimitPerUnit}
								/>
							</NSRow>
						</NSColumn>
					);
				}
			}
		);

		return (
			<EmailSenderLayout<ProviderRow, ProviderRow>
				{...this.props}
				pages={{
					entity: EmailSenderEntities.provider(this.props),
					edit: {
						...this.props,
						ui: {
							getEntity: () =>
							{
								let name = this.NSBoxString_Name.current?.getValue() ?? "";
								let type = this.NSBoxEnum_Type.current?.getValueEnumOne(ProviderType, ProviderType.Gmail) ?? ProviderType.Gmail;
								let meta = null;

								if (type === ProviderType.AWS)
								{
									let region = this.NSBoxString_Region.current?.getValue() ?? "";
									let access_key = this.NSBoxSecret_AccessKey.current?.getValue() ?? "";
									let secret_key = this.NSBoxSecret_SecretKey.current?.getValue() ?? "";
									let from = this.NSBoxString_From.current?.getValue() ?? "";
									meta = { region, access_key, secret_key, from };
								}

								if (type === ProviderType.SMTP)
								{
									let host = this.NSBoxString_Host.current?.getValue() ?? "";
									let port = this.NSBoxInteger_Port.current?.getValue() ?? "";
									let username = this.NSBoxSecret_Username.current?.getValue() ?? "";
									let password = this.NSBoxSecret_Password.current?.getValue() ?? "";
									meta = {
										host, port, username, password
									};
								}

								// Limit
								let limit: boolean = this.NSBoxBoolean_Limit.current?.getValueBool() ?? false;
								let limit_count: number | null = null;
								let limit_per_value: number | null = null;
								let limit_per_unit: ProviderLimitPerUnit | null = null;
								if (limit)
								{
									limit_count = this.NSBoxInteger_Limit_Count.current?.getValue() ?? 0;
									limit_per_value = this.NSBoxInteger_Limit_Per_Value.current?.getValue() ?? 0;
									limit_per_unit = this.NSBoxEnum_Limit_Per_Unit.current?.getValueEnumOne(ProviderLimitPerUnit, ProviderLimitPerUnit.Second) ?? ProviderLimitPerUnit.Second;
								}

								return {
									id: "",
									user_id: "",
									workspace_id: "",
									name,
									type,
									meta,
									e_verified: true,
									limit,
									limit_count,
									limit_per_value,
									limit_per_unit,
									created_at: new Date(),
									updated_at: new Date()
								}
							},
							setEntity: (entity) =>
							{
								this.NSBoxString_Name.current?.setValue(entity.name);
								this.NSBoxEnum_Type.current?.setValue(entity.type);
								this.setState({ type: entity.type }, () =>
								{
									if (entity.type === ProviderType.AWS)
									{
										this.NSBoxString_Region.current?.setValue(entity.meta.region);
										this.NSBoxSecret_AccessKey.current?.setValue(entity.meta.access_key);
										this.NSBoxSecret_SecretKey.current?.setValue(entity.meta.secret_key);
										this.NSBoxString_From.current?.setValue(entity.meta.from);
									}
									if (entity.type === ProviderType.SMTP)
									{
										this.NSBoxString_Host.current?.setValue(entity.meta.host);
										this.NSBoxInteger_Port.current?.setValue(entity.meta.port);
										this.NSBoxSecret_Username.current?.setValue(entity.meta.username);
										this.NSBoxSecret_Password.current?.setValue(entity.meta.password);
									}
								});
								this.NSBoxBoolean_Limit.current?.setValue(entity.limit);
								if (entity.limit)
								{
									this.NSBoxInteger_Limit_Count.current?.setValue(entity.limit_count);
									this.NSBoxInteger_Limit_Per_Value.current?.setValue(entity.limit_per_value);
									this.NSBoxEnum_Limit_Per_Unit.current?.setValue(entity.limit_per_unit);
								}
							},
							extraTabs
						}
					}
				}}
			>
				<NSColumn>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Name}
							title="Name"
							required
						/>
						<NSBoxEnum<ProviderType>
							ref={this.NSBoxEnum_Type}
							title="Type"
							multiple={false}
							required
							getEnumObject={() => ProviderType}
							onChanged={() =>
							{
								let type = this.NSBoxEnum_Type.current?.getValueEnumOne(ProviderType, ProviderType.Gmail) ?? ProviderType.Gmail;
								this.setState({ type });
							}}
							searchable={false}
						/>
					</NSRow>
					{
						this.state.type === ProviderType.AWS &&
						<>
							<NSRow>
								<NSBoxString
									ref={this.NSBoxString_Region}
									required
									title="Region"
								/>
								<NSBoxString
									ref={this.NSBoxString_From}
									required
									title="From"
								/>
							</NSRow>
							<NSRow>
								<NSBoxSecret
									ref={this.NSBoxSecret_AccessKey}
									account={this.props.account}
									notifier={this.props.notifier}
									url={this.props.url}
									required
									title="Access Key"
								/>
								<NSBoxSecret
									ref={this.NSBoxSecret_SecretKey}
									account={this.props.account}
									notifier={this.props.notifier}
									url={this.props.url}
									required
									title="Secret Key"
								/>
							</NSRow>
						</>
					}
					{
						this.state.type === ProviderType.SMTP &&
						<>
							<NSRow>
								<NSBoxString
									ref={this.NSBoxString_Host}
									required
									title='Host'
								/>
								<NSBoxInteger
									ref={this.NSBoxInteger_Port}
									required
									title='Port'
								/>
							</NSRow>
							<NSRow>
								<NSBoxSecret
									ref={this.NSBoxSecret_Username}
									account={this.props.account}
									notifier={this.props.notifier}
									url={this.props.url}
									required
									title='Username'
								/>
								<NSBoxSecret
									ref={this.NSBoxSecret_Password}
									account={this.props.account}
									notifier={this.props.notifier}
									url={this.props.url}
									required
									title='Password'
								/>
							</NSRow>
						</>
					}
				</NSColumn>
			</EmailSenderLayout >
		);
	}
}